import gql from 'graphql-tag';

export const EXPERIMENTS_QUERY = gql`
  query ExperimentsQuery($filter: ExperimentsFilterInput!, $first: Int, $after: String) {
    experiments(filter: $filter, first: $first, after: $after) {
      edges {
        node {
          id
          name
          type
          status
          endTime
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;
